import { useAppStore } from '@/hooks/useAppStore';

//injecting theme into app
export const ClientStyle = () => {

  const clientConfig = useAppStore((state) => state.clientConfig);

  if (!clientConfig) return null;

  const lightTheme = clientConfig.theme?.light;

  const styleVars = `
    :root {
      --container-bg-color: ${lightTheme?.containerBackgroundColor || '#e4e4e4'};
      --container-bg-image: ${lightTheme?.containerBackgroundImage ? "url('" + lightTheme?.containerBackgroundImage + "')" : "none"};
      --chat-bg-color: ${lightTheme?.chatBackgroundColor || ''};
      --chat-bg-image: url('${lightTheme?.chatBackgroundImage || ''}');
      --header-bg-color: ${lightTheme?.headerBackgroundColor || '#fff'};
      --header-bg-image: url('${lightTheme?.headerBackgroundImage || ''}');
      --color-chotto-border: ${lightTheme?.containerBorderColor || ''};
      --color-chotto-primary: ${lightTheme?.primaryColor || ''};
      --color-chotto-font-primary: ${lightTheme?.primaryFontColor || '#000'};
    }
  `;

  const darkTheme = clientConfig.theme?.dark;
  const styleVarsDark = `
    .dark {
      --container-bg-color: ${darkTheme?.containerBackgroundColor || '#333'};
      --container-bg-image: ${darkTheme?.containerBackgroundImage ? "url('" + darkTheme?.containerBackgroundImage + "')" : "none"};
      --chat-bg-color: ${darkTheme?.chatBackgroundColor || '#111'};
      --chat-bg-image: url('${darkTheme?.chatBackgroundImage || ''}');
      --header-bg-color: ${darkTheme?.headerBackgroundColor || '#111'};
      --header-bg-image: url('${darkTheme?.headerBackgroundImage || ''}');
      --header-bg-image: url('${darkTheme?.headerBackgroundImage || ''}');
      --color-chotto-border: ${darkTheme?.containerBorderColor || ''};
      --color-chotto-primary: ${darkTheme?.primaryColor || ''};
      --color-chotto-font-primary: ${lightTheme?.primaryFontColor || '#000'};
    }
  `

  return <style>
    {styleVars}
    {styleVarsDark}
  </style>;
};
